import { getServerUrl } from 'mt-shared';

const SERVER_URL: string = getServerUrl();

export function getDomain(): string {
  const urlSplitString: string = '//';

  let domain: string = SERVER_URL;
  if (SERVER_URL.includes(urlSplitString)) {
    domain = SERVER_URL.split(urlSplitString)[1];
  }
  return domain;
}

export function genericizeUrlHash(urlHash: string): string {
  if (urlHash.length === 0) return urlHash;
  const tokens: any = urlHash.split('/');
  const lastToken: string = tokens[tokens.length - 1];
  const searchIndex: number = lastToken.search(/[\?;]/);
  if (searchIndex !== -1) {
    // strip query params
    tokens[tokens.length - 1] = lastToken.substring(0, searchIndex);
  }
  const tokensGenericized: any = tokens.map(token => {
    return token.search(/[0-9]/) === -1 ? token : '?';
  });
  return tokensGenericized.join('/');
}

export const isMaintenancePage = (): boolean => !!window.location.hash.startsWith('#/maintenance/');
